import { PopUpManager, WizPopUp } from '@wizeoo/akm-component-lib';
import { WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import { PivotCellEditPopData } from '../../../manager/widgets/i-widget';
import { PivotCellEditPop } from './renderers/cells/pivot-cell-edit.pop';
import { PivotCellFilterkeyEditPop } from './renderers/cells/pivot-cell-filterkey-edit.pop';
import { PivotCellCrosskeyEditPop } from './renderers/cells/pivot-cell-crosskey-edit.pop';
import { PivotCellListEditPop } from './renderers/cells/pivot-cell-list-edit.pop';
import { FIELD_KIND, FeiKeyDef } from '@wizeoo/akm-compute-lib';
import { PopUtils } from '../../../framework/components/pop/pop-utils';
import { AlkEvent } from '../../../framework/events/alk.event';
import { PivotCellWorkflowEditPop } from './renderers/cells/pivot-cell-workflow-edit.pop';
import { PivotCellThresholdEditPop } from './renderers/cells/pivot-cell-threshold-edit.pop';
import { WIDGET_GLOBAL_KIND } from '../../../model/enums';


// ouverture des pops des pivots
export class PopMaker {
 
  /* ##############################################################################
            pops de saisie en masse
     ############################################################################## */

  // popUp de saisie en masse
  private static _massPop: WizPopUp;
  // popUp spécifique pour la saisie de mesures de type liste
  private static _listPop: WizPopUp;

  // popUp pour l'édition en masse depuis les headers (pour éviter ref circulaires)
  private static _headerMassPop: WizPopUp;

  public static openHeaderMassPop(e: AlkEvent):void {
    let data: PivotCellEditPopData= e.data[0];
    let popupPosition: { x: number; y: number } = e.data[1];
    
    let popClass: any = PivotCellFilterkeyEditPop; // type de popUp selon la nature de la donnée

    let baseWidth: number = PivotCellFilterkeyEditPop.baseWidth;
    let baseHeight: number = PivotCellFilterkeyEditPop.baseHeight;
    
    if (this._massPop && PopUpManager.exist(this._massPop)) {
        // suppression de l'instance existante
        this._massPop.hide();
    }

    this._headerMassPop = new WizPopUp(
      popClass,
      false,
      false,
      null,
      baseWidth + 'px',
      baseHeight + 'px',
      data
    );
    const bestXY: [number, number] = PopUtils.setPopCoord(
      popupPosition,
      this._headerMassPop,
      WIZ_PHYSIC_POSITION.BOTTOM_RIGHT
    );
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    this._headerMassPop.customPosition = targetPosition;
  
    // ouverture de la pop
    this._headerMassPop.show();
  }


  public static openMassPop(e: AlkEvent):void {
    let kind: string = (e.data as PivotCellEditPopData).kind;
    if(kind === WIDGET_GLOBAL_KIND.FREEDATA) {
      PopMaker.openFDVMassPopReally(e.data);
    } else {
      PopMaker.openMassPopReally(e.data);
    }

  }

  /** ouverture de la popUp de saisie en masse / ou pas pour les baselines */
  public static openMassPopReally( data: PivotCellEditPopData, ):void {
    
    let isFilterKey: boolean = !!data.isFilterKey;
    let popupPosition: { x: number; y: number } = data.pointer;
    let popClass: any = null; // type de popUp selon la nature de la donnée

    let baseWidth: number = PivotCellEditPop.baseWidth;
    let baseHeight: number = PivotCellEditPop.baseHeight;

    let useMassPop: boolean = true; // utilisation des pops classiques (pas la popUp de LIST)
    let locked: boolean = false; // pas défaut, un clic en dehors ferme
    // mais pas pour la popUp de mesure LIST

    let fkd: FeiKeyDef = data.fkd;
    if (isFilterKey || fkd.datakind === FIELD_KIND.FILTER) { // édition d'une filterkey ou d'une mesure de type filter    
      popClass = PivotCellFilterkeyEditPop;
    } else if (fkd.datakind === FIELD_KIND.CROSS_FILTER) { // édition d'un workflow
      // console.log('TODO TODO cross filter POP');
      popClass = PivotCellCrosskeyEditPop;
    }
      else if (fkd.datakind === FIELD_KIND.WORKFLOW) { // édition d'un workflow
      popClass = PivotCellWorkflowEditPop;
    } else { // édition d'une mesure
      if(fkd.datakind === FIELD_KIND.LIST){ // affichage d'une liste de valeurs
        popClass = PivotCellListEditPop;
        locked = true;
        useMassPop = false;
      } else if (fkd.datakind === FIELD_KIND.THRESHOLD){ // affichage d'une liste de valeurs ordonnées
        popClass = PivotCellThresholdEditPop;
        locked = true;
        useMassPop = false;
      } else {
        popClass = PivotCellEditPop;
      }
      
    }

    baseWidth = popClass.baseWidth;
    baseHeight = popClass.baseHeight;


    if(useMassPop) {
      if (this._massPop && PopUpManager.exist(this._massPop)) {
        // suppression de l'instance existante
        this._massPop.hide();
      }
      this._massPop = new WizPopUp(
        popClass,
        false,
        false,
        null,
        baseWidth + 'px',
        baseHeight + 'px',
        data
      );
      const bestXY: [number, number] = PopUtils.setPopCoord(
        popupPosition,
        this._massPop,
        WIZ_PHYSIC_POSITION.BOTTOM_RIGHT
      );
      const x: string = bestXY[0] + 'px';
      const y: string = bestXY[1] + 'px';

      //éviter le 0.0 si pas de dispo, plutôt le milieu de l'écran
      if(bestXY[0] === 0 && bestXY[1] === 0) {
        // pas de custom, on laisse au milieu
      } else {
        const targetPosition: any = { left: x, top: y }; // position physique
        this._massPop.customPosition = targetPosition;
      }

      // ouverture de la pop
      this._massPop.show();
    } else {
      if (this._listPop && PopUpManager.exist(this._listPop)) {
        // suppression de l'instance existante
        this._listPop.hide();
      }
      this._listPop = new WizPopUp(
        popClass,
        false,
        false,
        null,
        baseWidth + 'px',
        baseHeight + 'px',
        data
      );
      const bestXY: [number, number] = PopUtils.setPopCoord(
        popupPosition,
        this._listPop,
        WIZ_PHYSIC_POSITION.BOTTOM_RIGHT
      );
      const x: string = bestXY[0] + 'px';
      const y: string = bestXY[1] + 'px';
      const targetPosition: any = { left: x, top: y }; // position physique
      this._listPop.customPosition = targetPosition;
  
      // ouverture de la pop
      this._listPop.show();
    }
  }

  /** ouverture de la popUp de saisie pour les FDV */
  public static openFDVMassPopReally( data: PivotCellEditPopData):void {
    let popClass: any = null; // type de popUp selon la nature de la donnée

    let baseWidth: number = PivotCellEditPop.baseWidth;
    let baseHeight: number = PivotCellEditPop.baseHeight;

    let useMassPop: boolean = true; // utilisation des pops classiques (pas la popUp de LIST)
    let locked: boolean = false; // pas défaut, un clic en dehors ferme
    // mais pas pour la popUp de mesure LIST

    let popupPosition: { x: number; y: number } = data.pointer; 

    // interceptions. Prise du fkd, pour les fausses mesures des argRenderers
    if(data.fkd?.datakind === FIELD_KIND.WORKFLOW || data.arg?.dataType === FIELD_KIND.WORKFLOW) {
      popClass = PivotCellWorkflowEditPop;
    } else if(data.fkd?.datakind === FIELD_KIND.THRESHOLD || data.arg?.dataType === FIELD_KIND.THRESHOLD) {
      popClass = PivotCellThresholdEditPop;
      locked = true;
      useMassPop = false;
    } else if(data.fkd?.datakind === FIELD_KIND.LIST || data.arg?.dataType === FIELD_KIND.LIST) {
      popClass = PivotCellListEditPop;
      locked = true;
      useMassPop = false;
    } else if (data.arg?.dataType === FIELD_KIND.OBJECT) { // sous objet
      popClass = PivotCellFilterkeyEditPop;
    } else {
      // console.log('TODO');
      popClass = PivotCellEditPop;
    }

    baseWidth = popClass.baseWidth;
    baseHeight = popClass.baseHeight;

    if(useMassPop) {
      if (this._massPop && PopUpManager.exist(this._massPop)) {
        // suppression de l'instance existante
        this._massPop.hide();
      }
      this._massPop = new WizPopUp(
        popClass,
        false,
        false,
        null,
        baseWidth + 'px',
        baseHeight + 'px',
        data
      );
      const bestXY: [number, number] = PopUtils.setPopCoord(
        popupPosition,
        this._massPop,
        WIZ_PHYSIC_POSITION.BOTTOM_RIGHT
      );
      const x: string = bestXY[0] + 'px';
      const y: string = bestXY[1] + 'px';

      //éviter le 0.0 si pas de dispo, plutôt le milieu de l'écran
      if(bestXY[0] === 0 && bestXY[1] === 0) {
        // pas de custom, on laisse au milieu
      } else {
        const targetPosition: any = { left: x, top: y }; // position physique
        this._massPop.customPosition = targetPosition;
      }

      // ouverture de la pop
      this._massPop.show();
    } else {
      if (this._listPop && PopUpManager.exist(this._listPop)) {
        // suppression de l'instance existante
        this._listPop.hide();
      }
      this._listPop = new WizPopUp(
        popClass,
        false,
        false,
        null,
        baseWidth + 'px',
        baseHeight + 'px',
        data
      );
      const bestXY: [number, number] = PopUtils.setPopCoord(
        popupPosition,
        this._listPop,
        WIZ_PHYSIC_POSITION.BOTTOM_RIGHT
      );
      const x: string = bestXY[0] + 'px';
      const y: string = bestXY[1] + 'px';
      const targetPosition: any = { left: x, top: y }; // position physique
      this._listPop.customPosition = targetPosition;
  
      // ouverture de la pop
      this._listPop.show();
    }
  }


}
